import styled from "styled-components";
import {SearchPCIconBoxDefault} from "./search-pc-icon.default.box";

// because on MrGreen the border of the search input is 2px instead of 1px we must adjust the position of the icon
export const SearchPCIconMrGreenBox = styled(SearchPCIconBoxDefault)`
    left: 0.8rem;
`;